import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  ShimmerParentContainer,
  ShimmerContainer,
  ShimmerDocInfoContainer,
  ShimmerDocTextContainer
} from './VeriffFailureShimmer.styles';
import { skeletonProps } from './VeriffFailureShimmer.types';

export const VeriffFailureShimmer: React.FC = () => {
  return (
    <ShimmerParentContainer>
      <ShimmerContainer>
        <Skeleton circle height={64} width={64} {...skeletonProps} />
        <Skeleton height={19} width={280} {...skeletonProps} />
        <Skeleton height={19} width={200} {...skeletonProps} />
        <Skeleton height={16} width={320} count={2} {...skeletonProps} />

        <ShimmerDocInfoContainer>
          <ShimmerDocTextContainer>
            <Skeleton height={24} width="70%" {...skeletonProps} />
            <Skeleton height={22} width="90%" {...skeletonProps} />
            <Skeleton height={22} width="50%" {...skeletonProps} />
          </ShimmerDocTextContainer>
          <Skeleton height={48} width={48} {...skeletonProps} />
        </ShimmerDocInfoContainer>

        <Skeleton height={48} width={450} borderRadius={8} {...skeletonProps} />
        <Skeleton height={22} width={150} {...skeletonProps} />
      </ShimmerContainer>
    </ShimmerParentContainer>
  );
};

export default VeriffFailureShimmer;
